export default __webpack_public_path__ + "static/media/GR00012-languages_card_2.d6dafd48.svg";